document.addEventListener('DOMContentLoaded', () => {
  const PERSONALIZED_LABEL_VARIANT_ID = 30298083983454;
  const PERSONALIZED_LABEL_TITLE = 'PERSONALIZED LABEL';
  const MAX_PERSONALIZATION_LENGTH = 15;

  const modal = document.getElementById('bb-personalized-label-modal');
  const closeButton = document.getElementById('bb-label-modal-close');
  const input = document.getElementById('bb-personalization-input');
  const addButton = document.getElementById('bb-add-personalized-label');
  const error = document.getElementById('bb-label-modal-error');

  if (!modal || !input || !addButton) return;

  const root = window.Shopify?.routes?.root || '/';

  const resetModal = () => {
    input.value = '';

    addButton.disabled = true;
    addButton.removeAttribute('aria-busy');
    addButton.textContent = 'ADD LABEL — $15';

    if (error) {
      error.hidden = true;
      error.textContent = 'Please enter your personalization.';
    }
  };

  const openModal = () => {
    resetModal();

    if (!modal.open) {
      modal.showModal();
    }

    window.requestAnimationFrame(() => {
      input.focus();
    });
  };

  const closeModal = () => {
    if (modal.open) {
      modal.close();
    }
  };

  const getMonkCard = (button) => {
    return button.closest('li');
  };

  const isPersonalizedLabelCard = (button) => {
    const card = getMonkCard(button);

    if (!card) return false;

    const cardText = (card.textContent || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase();

    return cardText.includes(PERSONALIZED_LABEL_TITLE);
  };

  /*
   * Intercept only the Personalized Label card.
   * All other Monk add-ons keep their existing direct Add behavior.
   */
  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const button = event.target.closest(
        'button.mr-actions__atc-button'
      );

      if (!button) return;
      if (!isPersonalizedLabelCard(button)) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      openModal();
    },
    true
  );

  closeButton?.addEventListener('click', () => {
    closeModal();
  });

  /*
   * Close when clicking the dialog backdrop.
   */
  modal.addEventListener('click', (event) => {
    if (event.target === modal) {
      closeModal();
    }
  });

  modal.addEventListener('close', () => {
    resetModal();
  });

  /*
   * Enable the Add button only when a value exists.
   */
  input.addEventListener('input', () => {
    const personalization = input.value.trim();
    const hasValue = personalization.length > 0;

    addButton.disabled = !hasValue;

    if (hasValue && error) {
      error.hidden = true;
    }
  });

  addButton.addEventListener('click', async () => {
    const personalization = input.value.trim();

    if (!personalization) {
      addButton.disabled = true;

      if (error) {
        error.textContent = 'Please enter your personalization.';
        error.hidden = false;
      }

      input.focus();
      return;
    }

    /*
     * Safety validation.
     * HTML maxlength already stops normal input beyond 15 characters.
     */
    if (personalization.length > MAX_PERSONALIZATION_LENGTH) {
      if (error) {
        error.textContent =
          'Personalization must be 15 characters or fewer.';
        error.hidden = false;
      }

      input.focus();
      return;
    }

    if (addButton.getAttribute('aria-busy') === 'true') {
      return;
    }

    addButton.setAttribute('aria-busy', 'true');
    addButton.disabled = true;
    addButton.textContent = 'ADDING…';

    if (error) {
      error.hidden = true;
    }

    document.documentElement.dispatchEvent(
      new CustomEvent('theme:loading:start', {
        bubbles: true
      })
    );

    try {
      /*
       * Ask Prestige which sections need to be returned
       * with the cart response.
       */
      const sectionsToBundle = [];

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: {
            sections: sectionsToBundle
          }
        })
      );

      /*
       * Add Personalized Label with the same internal Monk
       * property plus our Personalization line item property.
       */
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: PERSONALIZED_LABEL_VARIANT_ID,
          quantity: 1,
          properties: {
            _mr: '1',
            Personalization: personalization
          },
          sections: sectionsToBundle.join(','),
          sections_url: window.location.pathname
        })
      });

      const responseJson = await response.json();

      if (!response.ok) {
        throw new Error(
          responseJson?.description ||
          'The personalized label could not be added.'
        );
      }

      /*
       * Fetch the current full cart so Prestige receives
       * the cart object it expects.
       */
      const cartResponse = await fetch(`${root}cart.js`, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!cartResponse.ok) {
        throw new Error('The cart could not be refreshed.');
      }

      const cart = await cartResponse.json();

      cart.sections = responseJson.sections || {};

      /*
       * Close personalization modal before opening cart drawer.
       */
      closeModal();

      /*
       * Trigger Prestige's native cart flow.
       * Cart Drawer refreshes itself and opens.
       */
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'variant:add',
            onSuccessDo: 'force_open_drawer',
            cart: cart
          }
        })
      );
    } catch (requestError) {
      console.error(
        '[BERRY BLUSH] Personalized Label add failed:',
        requestError
      );

      if (error) {
        error.textContent =
          'We could not add the personalized label. Please try again.';
        error.hidden = false;
      }

      addButton.disabled = false;
      addButton.removeAttribute('aria-busy');
      addButton.textContent = 'ADD LABEL — $15';
    } finally {
      document.documentElement.dispatchEvent(
        new CustomEvent('theme:loading:end', {
          bubbles: true
        })
      );
    }
  });
});